export default (callback, ms) => {
  let timeoutId = null;

  return (...args) => {
    if (timeoutId) {
      return;
    }

    timeoutId = window.setTimeout(() => {
      callback(...args);

      window.clearTimeout(timeoutId);
      timeoutId = null;
    }, ms);
  };
};
